export default function TutorProfileRate({subject, level, subjectLevels, modality}) {
  const subjectAndLevelPresent = !!(subject?.slug && level?.slug)
  const subjectLevel = (() => {
    return subjectLevels.find(subjectLevel => {
      const otherSubject = subjectLevel.subject
      const otherLevel = subjectLevel.level

      if(subject && level) {
        return otherSubject.id === subject.id && otherLevel.id === level.id
      } else if(subject) {
        return otherSubject.id === subject.id
      } else if(level) {
        return otherLevel.id === level.id
      }
    })
  })()
  const rateAttr = modality === 'inPerson' ? 'inPersonRate' : 'onlineRate'
  const formattedRateAttr = rateAttr === 'inPersonRate' ? 'formattedInPersonRate' : 'formattedOnlineRate'
  const lowestRate = (() => {
    const filteredSubjectLevels = subjectLevels.filter(subjectLevel => !!subjectLevel[rateAttr])
    const sorted = filteredSubjectLevels.sort((a, b) => a[rateAttr] - b[rateAttr])
    return sorted && sorted[0] && sorted[0][formattedRateAttr]
  })()

  return (
    <span>
      {subjectAndLevelPresent ?
        <span>
          {subjectLevel[formattedRateAttr]}
        </span>
        :
        <span>
          <small>from </small>
          {lowestRate}
        </span>
      }
    </span>
  )
}
